import styled from 'styled-components';
import Button from '@mui/material/Button';

export const pdfStylesToOverride = `
  * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }

  /* Chromium exports box-shadow as a PDF soft mask, which Apple's PDF engine
     (macOS Preview, Quick Look, iOS Safari/Mail/Files) paints as a solid gray
     block behind the cards. These styles only reach the PDF, so the on-screen
     summary keeps its shadows. */
  * { box-shadow: none !important; }

  @page {
    size: A4;
    margin: 47mm 15mm 15mm 15mm;
  }

  html,
  body {
    margin: 0;
    padding: 0;
  }
`;

export const SummaryButtonDiv = styled.div`
  display: flex;
  width: 100%;
  /* min-height instead of a fixed height: on narrow screens the link wraps
     onto several lines and a fixed 14dvh box let it overflow into the text
     above and get clipped below. */
  min-height: 14dvh;
  padding: 16px 12px;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
`;

export const SummaryButton = styled.button<{ $fontSize?: string }>`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #ff780c;
  text-decoration: underline;
  font-family: 'Roboto', sans-serif;
  font-size: ${({ $fontSize }) => $fontSize || '30px'};
  font-weight: 700;
  line-height: 1.3;
  max-width: 100%;
  white-space: normal;
  overflow-wrap: anywhere;

  @media (max-width: 600px) {
    /* the size is copied from the "leave survey" link so the two match on
       desktop; on phones that can be huge, so cap it to keep the link readable */
    font-size: min(${({ $fontSize }) => $fontSize || '30px'}, 24px);
  }
`;

export const ExclamationMark = styled.span`
  color: #e30613;
  text-decoration: none;
  display: inline-block;
  font-size: 1.6em;
  font-weight: 900;
  margin: 0 0.35em;
`;

export const SummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #ff780c;
  padding: 2rem 3rem;
  margin-top: 4vh;
  gap: 2rem;
  margin-bottom: 6vh;
  width: clamp(320px, 85vw, 960px);
  place-self: center;
  background-color: #fafafa;
  box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.12),
    0 1.5px 4px 0 rgba(0, 0, 0, 0.06);

  @media (max-width: 768px) {
    padding: 1.25rem;
    width: 95vw;
    gap: 1.25rem;
  }
`;

export const Body = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  justify-content: center;
  align-items: center;
`;

export const Header = styled.div`
  display: flex;
  width: 100%;
  padding-bottom: 1rem;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e0e0e0;
`;

export const SummaryTitle = styled.h2`
  font-family: 'Roboto', sans-serif;
  font-size: clamp(16px, 1.6vw, 22px);
  font-weight: 700;
  color: #333333;
  margin: 0;
`;

export const CardQuestionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.25rem;
  justify-items: stretch;
  width: 100%;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const DownloadButton = styled(Button)`
  background-color: #ff780c !important;
  color: white !important;
  border-radius: 18px !important;
  padding: 0.5rem 1.5rem !important;
  font-weight: 600 !important;
  text-transform: none !important;

  &.Mui-disabled {
    background-color: #ffb37a !important;
    color: white !important;
  }
`;
